import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '../models/location';

import { SnotifyService } from 'ng-snotify';
@Injectable()
export class LocationService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }
 
  public getAll(id): Promise<Location[]> {
    return new Promise((resolve, reject) => {
      this.http.get<Location[]>('api/location/getall?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  
}
